exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "._2wYqXkr4KupA4yxho7WeOV {\n  display: flex;\n  justify-content: flex-end;\n}", "", {"version":3,"sources":["/home/forge/vf.leadpm.io/frontend/src/Modals/ExportHistory/Components/Footer/Component.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,0BAA0B;CAC3B","file":"Component.css","sourcesContent":[".footer {\n  display: flex;\n  justify-content: flex-end;\n}"],"sourceRoot":""}]);

// exports
exports.locals = {
	"footer": "_2wYqXkr4KupA4yxho7WeOV"
};